import { render, staticRenderFns } from "./SupportSidepanel.vue?vue&type=template&id=1ca62a72&"
import script from "./SupportSidepanel.vue?vue&type=script&lang=js&"
export * from "./SupportSidepanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports